module.exports = __webpack_public_path__ + "h5/img/left-banner.a99f931e.jpg";